export const QUERY_KEY_MANAGE_PLAN_LINK = 'ManagePlanLink'
